import {
  Button,
  type ButtonOwnProps,
  IconButton,
  Tooltip,
  useTheme,
} from "@mui/material"
import { EyeOff } from "react-feather"

export const HiddenIconBtn = ({
  hidden = false,
  size = "small",
  handleClick,
}: {
  hidden?: boolean
  size?: ButtonOwnProps["size"]
  handleClick?: () => void
}) => {
  const { color, bgcolor, grey, border, text } = useConfHidden({
    hidden,
  })

  const handleHide = () => {
    if (hidden) return
    handleClick?.()
  }

  return (
    <Tooltip title={text}>
      {/*
        Add span to keep Tooltip active when the Button is disabled.
        https://v6.mui.com/material-ui/react-tooltip/#disabled-elements
      */}
      <span>
        <IconButton
          onClick={handleHide}
          size={size}
          sx={{
            border,
            bgcolor,
            svg: {
              transition: "stroke 0.2s ease-in-out",
            },
            "&:hover svg": {
              stroke: grey,
              transition: "stroke 0.2s ease-in-out",
            },
          }}
          disabled={hidden}
        >
          <EyeOff size={size === "small" ? 12 : 24} color={color} />
        </IconButton>
      </span>
    </Tooltip>
  )
}

export const HiddenBtn = ({
  hidden,
  handleClick,
}: { hidden: boolean; handleClick?: () => void }) => {
  const { color, bgcolor, border, hoverColor, hoverBgcolor, text } = useConfHidden({
    hidden,
  })

  const handleHide = () => {
    if (hidden) return
    handleClick?.()
  }
  return (
    <Button
      onClick={handleHide}
      variant={hidden ? "outlined" : "contained"}
      startIcon={<EyeOff />}
      sx={{
        border,
        color,
        bgcolor,
        "&:hover": {
          color: hoverColor,
          bgcolor: hoverBgcolor,
        },
      }}
      disabled={hidden}
      size="large"
    >
      {text}
    </Button>
  )
}

const useConfHidden = ({ hidden }: { hidden: boolean }) => {
  const { palette } = useTheme()
  const grey = palette.grey.light
  const baseConf = {
    border: `1px solid ${grey}`,
    grey,
    hoverColor: grey,
    hoverBgcolor: "transparent",
  }

  if (hidden) {
    return {
      ...baseConf,
      color: grey,
      bgcolor: "transparent",
      text: "Opération masquée",
    }
  }
  return {
    ...baseConf,
    color: palette.common.white,
    bgcolor: grey,
    text: "Ne souhaite pas participer",
  }
}
